// store/providerOrderSendStatus.js — intranet-001
//
// Reenvío manual de un ProviderOrder fallido (POST /provider-orders/:id/resend, api-003) desde
// la página `dashboard/economato/envios-proveedores`. El listado en sí (GET
// /provider-orders/send-status/:page, api-005) NO pasa por este módulo: lo sirve el mixin
// `forms` como cualquier otro listado paginado del dashboard.

export default {
	namespaced: true,

	actions: {
		// resendProviderOrder: el resultado del intento en sí (éxito o fallo de ENVÍO al
		// proveedor) viaja SIEMPRE en el body 200 de la respuesta (`state`/`error_message`,
		// ver api-003) — nunca es un error HTTP. Un error real (400/403/404/red) sí se
		// relanza como Error, con el mismo criterio de extracción de mensaje que
		// purchaseOrderCart.js:submitOrder (intranet-002).
		async resendProviderOrder({ commit }, providerOrderId) {
			if (!providerOrderId || typeof providerOrderId !== "number") {
				throw new Error("Invalid provider order ID");
			}

			const token = window.localStorage.getItem("auth._token.local");
			if (!token) {
				throw new Error("No authentication token found");
			}

			try {
				const response = await this.$axios.post(
					`/provider-orders/${providerOrderId}/resend`,
					{},
					{
						headers: {
							Authorization: token,
						},
					},
				);

				return response.data;
			} catch (error) {
				// SECURITY: Handle auth errors (mismo patrón que purchaseOrderCart.js)
				if (error.response && (error.response.status === 401 || error.response.status === 403)) {
					window.location.href = "/login";
					throw new Error("Sesión expirada. Por favor, inicia sesión nuevamente.");
				}

				const errorMessage =
					(error.response && error.response.data && (error.response.data.details || error.response.data.error)) ||
					error.message ||
					"Error al reenviar el pedido";

				// intranet-015: el código máquina (p.ej. "send_in_progress", api-034) se preserva
				// en `.code` — el mensaje humano de `errorMessage` no basta para que la página
				// distinga ese caso concreto de cualquier otro error real.
				const wrapped = new Error(errorMessage);
				const code = error.response && error.response.data && error.response.data.error;
				if (code) {
					wrapped.code = code;
				}
				throw wrapped;
			}
		},
	},
};
